import React from 'react';
import PropTypes from 'prop-types';

export default function ReadOnly(props) {
  const { children, condition, ...otherProps } = props;
  return (
    <div {...otherProps} style={condition ? { width: '100%' } : { width: '100%' }} className={condition ? 'read-only' : ''}>
      {children}
    </div>
  );
}
ReadOnly.propTypes = {
  children: PropTypes.any.isRequired,
  condition: PropTypes.bool,
};
ReadOnly.defaultProps = {
  condition: true,
};
